import React from 'react';
export function VerticalHeaderSection() {
  return <section className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-1875">
      <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-1876">
        EDMMax Fast Wire – Vertical
      </h2>
    </section>;
}